export const LOAD_REVIEWED_ARTICLES_REQUEST = 'holodeck/LOAD_REVIEWED_ARTICLES_REQUEST';
export const LOAD_REVIEWED_ARTICLES_SUCCESS = 'holodeck/LOAD_REVIEWED_ARTICLES_SUCCESS';
export const LOAD_REVIEWED_ARTICLES_FAILURE = 'holodeck/LOAD_REVIEWED_ARTICLES_FAILURE';

export const LOAD_UNIVERSE_COMPANIES_REQUEST = 'holodeck/LOAD_UNIVERSE_COMPANIES_REQUEST';
export const LOAD_UNIVERSE_COMPANIES_SUCCESS = 'holodeck/LOAD_UNIVERSE_COMPANIES_SUCCESS';
export const LOAD_UNIVERSE_COMPANIES_FAILURE = 'holodeck/LOAD_UNIVERSE_COMPANIES_FAILURE';
